<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.trendPunti }}</h2>
        <div class="chart-container">
          <chart [options]="trendPuntiChart.options" (load)="setChartInstance(trendPuntiChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.accantonamento }}</h2>
        <div class="chart-container">
          <chart [options]="accantonamentoChart.options" (load)="setChartInstance(accantonamentoChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>







// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/overview-loyalty-points/overview-loyalty-points.component.html